import React from 'react';
import { Menu, ActionIcon } from '@mantine/core';
import {
  IconDots,
  IconPlugConnected,
  IconEdit,
  IconTrash,
} from '@tabler/icons-react';
import { DeviceConfig } from '../../types/devices';

interface DeviceActionsMenuProps {
  device: DeviceConfig;
  onTest: (device: DeviceConfig) => void;
  onEdit: (device: DeviceConfig) => void;
  onDelete: (device: DeviceConfig) => void;
}

export const DeviceActionsMenu: React.FC<DeviceActionsMenuProps> = ({
  device,
  onTest,
  onEdit,
  onDelete,
}) => {
  return (
    <Menu shadow="md" width={160} position="bottom-end">
      <Menu.Target>
        <ActionIcon variant="subtle" color="gray">
          <IconDots size={18} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPlugConnected size={14} />}
          onClick={() => onTest(device)}
        >
          Test
        </Menu.Item>
        <Menu.Item
          leftSection={<IconEdit size={14} />}
          onClick={() => onEdit(device)}
        >
          Edit
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          leftSection={<IconTrash size={14} />}
          color="red"
          onClick={() => onDelete(device)}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
